import { isWithinInterval, parseISO, startOfDay } from 'date-fns';

import { EDetailsMode } from 'components/Pages/Admin/Itinerary/Details/types';
import { markEmptyPages } from 'components/Pages/Admin/shared/ItinerariesItemLanding/utils';
import { EPageRole } from 'detailsv2/LandingV2/Page/types';
import { isEmpty } from 'ramda';
import { isSchedulesEmpty } from 'utils/itineraries/functions/builderUtils';
import { isNotDefined } from 'utils/ramda';

import { IPage, IProposal } from './itineraryDetails/types';

export function isCurrentProposal(proposal: IProposal): boolean {
  if (!proposal) return false;
  if (proposal.type === 'lookbook') return false;
  if (proposal.type === 'itinerary' && !proposal.confirmed) return false;

  try {
    const pages = proposal.landing?.pages?.filter((page) => page?.datesRange && page.datesRange.start);
    if (!pages?.length) return false;

    let minDate: Date | null = null;
    let maxDate: Date | null = null;

    pages.forEach((page) => {
      const { start, end } = page.datesRange || {};
      if (!start) return;

      const startDate = parseISO(start);
      const endDate = parseISO(end || start);

      if (!minDate || startDate < minDate) minDate = startDate;
      if (!maxDate || endDate > maxDate) maxDate = endDate;
    });

    if (!minDate || !maxDate) return false;

    const currentDate = startOfDay(new Date());
    return isWithinInterval(currentDate, { start: minDate, end: maxDate });
  } catch (error) {
    console.warn(error);
    return false;
  }
}

export const getCurrentDatePage = (pages: IPage[]) => {
  const currentDate = startOfDay(new Date());

  return pages.find((page) => {
    if (!page?.datesRange?.start || !page?.datesRange?.end) return false;

    const isCurrentDateInPage = isWithinInterval(currentDate, {
      start: parseISO(page.datesRange.start),
      end: parseISO(page.datesRange.end),
    });

    return isCurrentDateInPage;
  });
};

function isOverviewEmpty(proposal: IProposal) {
  if (proposal.detailsMode === EDetailsMode.Original) {
    return isSchedulesEmpty(proposal.schedules);
  }
  return isEmpty(proposal.tripEvents);
}

export function getExcludedPageRoles(proposal: IProposal) {
  const exclude = [];

  if (isOverviewEmpty(proposal)) {
    exclude.push(EPageRole.SAFARI_OVERVIEW, EPageRole.TRAVEL_BRIEF);
  }

  if (isNotDefined(proposal.way)) {
    exclude.push(EPageRole.SAFARI_MAP);
  }

  return exclude;
}

export function getVisibleProposalPages(proposal: IProposal) {
  const excludeRoles = getExcludedPageRoles(proposal);
  const markedPages = markEmptyPages({ pages: proposal.landing.pages, excludeRoles });

  return markedPages.filter((page) => !page.hidden && !page.empty);
}
